import React from "react";
import history from "@linkfluence/core/history";
import { isAuthenticated, redirectToLogin } from "@linkfluence/visa/auth";

const Authenticated = ({ Component, client, ...props }) => {
  if (isAuthenticated()) {
    return <Component {...props} />;
  } else {
    const redirect = history.location.pathname + history.location.search;
    redirectToLogin(client, redirect);
    return null;
  }
};

export default Authenticated;
